import { render, staticRenderFns } from "./CardUserInfo.vue?vue&type=template&id=ff6d0822"
import script from "./CardUserInfo.vue?vue&type=script&lang=js"
export * from "./CardUserInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports